import React from 'react';

const Logo = ({ height = 48, className = '' }) => (
  <img
    src="/logo.png"
    alt="TESTETTİK"
    className={className}
    translate="no"
    data-testid="brand-logo"
    style={{ height: `${height}px`, width: 'auto' }}
  />
);

export const LogoMain = ({ height = 48, className = '' }) => (
  <Logo height={height} className={className} />
);

export const LogoGreen = ({ height = 48, className = '' }) => (
  <Logo height={height} className={className} />
);

export const LogoWhite = ({ height = 44, className = '' }) => (
  <Logo height={height} className={`brightness-0 invert ${className}`} />
);

export default LogoMain;
